import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { createFormData } from './utils/formData';

type HttpMethods = {
  get: <T, Q = {}>(url: string, query?: Q, config?: AxiosRequestConfig) => Promise<T | undefined>;
  post: <T, D = {}>(url: string, data?: D, config?: AxiosRequestConfig) => Promise<T>;
  put: <T, D = {}>(url: string, data?: D, config?: AxiosRequestConfig) => Promise<T>;
  delete: <T>(url: string, config?: AxiosRequestConfig) => Promise<T>;
};

const createHttpMethods = (axiosInstance: AxiosInstance): HttpMethods => ({
  get: <T, Q = {}>(url: string, query?: Q, config?: AxiosRequestConfig) => {
    return axiosInstance
      .get<T>(url, { ...config, params: query })
      .then((r) => r.data)
      .catch((e) => {
        throw e;
      });
  },

  post: <T, D = {}>(url: string, data?: D, config?: AxiosRequestConfig) => {
    const body = config?.headers?.['content-type'] === 'multipart/form-data' ? createFormData(data!) : data;
    return axiosInstance
      .post<T>(url, body, config)
      .then((r) => r.data)
      .catch((e) => {
        throw e;
      });
  },

  put: <T, D = {}>(url: string, data?: D, config?: AxiosRequestConfig) => {
    const body = config?.headers?.['content-type'] === 'multipart/form-data' ? createFormData(data!) : data;
    return axiosInstance
      .put<T>(url, body, config)
      .then((r) => r.data)
      .catch((e) => {
        throw e;
      });
  },

  delete: <T>(url: string, config?: AxiosRequestConfig) =>
    axiosInstance
      .delete<T>(url, config)
      .then((r) => r.data)
      .catch((e) => {
        throw e;
      }),
});

export { createHttpMethods };
export type { HttpMethods };
